module.exports = __webpack_public_path__ + "img/gt.6655d97d.svg";